import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_API_BASE_URL: z.string().min(1).default('/api/v1'),
    // API host pool: extra API bases (comma-separated, in failover order) tried when
    // VITE_API_BASE_URL stops answering, and the base64 SPKI Ed25519 key a remote host
    // list must verify under. Without the key only this build-time list is used.
    VITE_API_FALLBACK_BASE_URLS: z.string().optional(),
    VITE_EDGE_HOSTS_PUBLIC_KEY: z.string().min(40).optional(),
    // Must equal svc-setting's EDGE_HOSTS_ENVIRONMENT; a list signed for another
    // deployment is refused.
    VITE_EDGE_HOSTS_ENVIRONMENT: z.string().min(1).max(32).default('local'),
    // Optional dev/custom-build override; production resolves tenant by Host via /site-config.
    VITE_TENANT_ID: z.string().min(1).optional(),
    VITE_SENTRY_DSN: z.string().url().optional(),
    VITE_SENTRY_ENVIRONMENT: z.string().optional(),
    VITE_APP_VERSION: z.string().optional(),
    VITE_OTEL_COLLECTOR_URL: z.string().url().optional(),
    // The art library's public origin (one for dev and prod, ADR-0022). A game's
    // tile under it is loaded through Cloudflare Image Transformations, resized.
    VITE_IMG_ORIGIN: z.string().url().default('https://img.b1fr0st.com'),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});

export type Env = typeof env;
